<template>
    <v-container fluid>
        <v-col cols="12">
            <!--Datatable-->
            <ExpensesList :search_enabled="true"></ExpensesList>
        </v-col>
    </v-container>
</template>

<script>
    import ExpensesList from '../../components/ExpensesList.vue'

    export default {
        components: {
            ExpensesList
        }
    }
</script>


